import { render, staticRenderFns } from "./grid-import-text-editor-component.vue?vue&type=template&id=596ad3e7"
import script from "./grid-import-text-editor-component.vue?vue&type=script&lang=ts"
export * from "./grid-import-text-editor-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
